



















import Vue from 'vue'

export default Vue.extend({
    data: () => ({
        filesToUpload: [],
        isLoading: false,
        rispostaServer: '',
        eUnComuneBonificato: false
    }),
    computed: {
        canUpload() {
            return this.filesToUpload.length > 0
        }
    },
    methods: {
        setFiles(event) {
            this.filesToUpload = event.target.files
        },
        async uploadShapeFiles() {
            this.isLoading = true
            try {
                const postData = new FormData()
                for (const file of this.filesToUpload) {
                    postData.append(`file_data`, file)
                }
                const response = await Vue.axios.post('/puntiluce/upload_shape_files/', postData, {
                    params: { e_un_comune_bonificato: this.eUnComuneBonificato }
                })
                this.rispostaServer = 'Tutto è andato bene'
            } catch (err) {
                console.error(err)
                this.rispostaServer = `È successo un errore ${err.response.data}`.substring(0, 100)
            } finally {
                this.isLoading = false
            }
        },
        async caricaStatistiche() {
            const response = await Vue.axios.get('/puntiluce/stato_rilevamenti.json')
            this.statistiche = response.data
        }
    },
    created() {
        this.caricaStatistiche()
    }
})
